import React from 'react';
import Carousel from '../Carousel';
import CardsPrincipal from '../CardsPrincipal';
import Separador from '../Separador';
import CardsSection from '../CardsSection';


const Home = () => {
  return (
    <div>
     
      <Carousel />
      <CardsPrincipal />
      <Separador />
      <CardsSection />
    </div>
  );
};

export default Home;